module.exports = __webpack_public_path__ + "2c4bd8f2465444d053ee8416381a4e0c.svg";